import Aos from '../components/aos'

/**
 * News/Journal/Stories Page
 */
const PageNews =( $ )=>{

	if ( $( 'body' ).hasClass( 'blog' ) ) {
		Aos();
	}
};

export default PageNews;
